import type Enums from '../types/api/Enums';
import { hasStringValue } from './equality';

/** The notice for an editor whom the lock endpoint reports as holding the record. */
export const editLockHolderMessage = (entity: Enums.EditLockEntity, editorName: string): string =>
  `${hasStringValue(editorName) ? editorName : 'Another user'} is currently editing this ${entity}`;
